import API from '@/services/endpoint'
import {FETCH_CURRENT_USER} from "../../mutation-types";
/**
 * Update current user information
 * @param {function} commit - The vuex commit function
 * @param {object} state - The vuex state object
 * @param  {object} payload comes from login vue
 * @return {object[]} A array of updated information about the current user
 */
export async function updateCurrentUser({commit, state,}, payload) {
  return new Promise(async(resolve, reject) => {
    try {
      const { updateProfileUrl } = state;
      let responseObj = await API.put(updateProfileUrl, payload);
      let { data: { message: { user } } } = responseObj;
      localStorage.setItem('user', JSON.stringify(user));
      commit('auth/FETCH_CURRENT_USER', user, { root: true })
      return resolve(responseObj.data)
    } catch (e) {
      // Safely access response data, fallback to error message if response is undefined
      const errorData = e.response && e.response.data ? e.response.data : { message: e.message || 'An error occurred' }
      reject(errorData)
    }
  })
}

/**
 * API POST Request to delete user
 */
export async function deleteHandler({commit, state,}, payload) {
  return new Promise(async(resolve, reject) => {
    try {
      const { deleteUrl } = state;
      let responseObj = await API.delete(deleteUrl, payload);
      return resolve(responseObj.data);
    } catch (e) {
      // Safely access response data, fallback to error message if response is undefined
      const errorData = e.response && e.response.data ? e.response.data : { message: e.message || 'An error occurred' }
      reject(errorData)
    }
  })
}

